import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { DEBUG } from 'Global/constants'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'SearchModuleContainer'

    static propTypes = {
      allRugs: PropTypes.array.isRequired,
      dones: PropTypes.object.isRequired,
      errors: PropTypes.object.isRequired,
      exportToExcel: PropTypes.func.isRequired,
      extendedFilters: PropTypes.object.isRequired,
      filteredRugs: PropTypes.array.isRequired,
      filters: PropTypes.object.isRequired,
      layout: PropTypes.string.isRequired,
      limit: PropTypes.number.isRequired,
      pagination: PropTypes.object.isRequired,
      pendings: PropTypes.object.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      removeQueryFromUrl: PropTypes.func.isRequired,
      resetSaveSearch: PropTypes.func.isRequired,
      rugs: PropTypes.array.isRequired,
      saveSearch: PropTypes.func.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      searchForm: PropTypes.bool.isRequired,
      sortBy: PropTypes.string.isRequired,
      sortOrder: PropTypes.string.isRequired,
      toggleLayout: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      toggleSearchForm: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      mySearchesSaveModalOpen: false,
    }

    handleExportToExcel = e => {
      const { allRugs, exportToExcel } = this.props

      e.preventDefault()
      exportToExcel(allRugs)
    }

    handleSaveSearch = name => {
      const { extendedFilters, filteredRugs, filters, pagination, saveSearch, user } = this.props

      if (DEBUG) {
        const currentResults = filteredRugs.slice(0, 4).map((r, i) => {
          return {
            ...r,
            picture: `/static/pictures/debug/${i}.jpg`,
          }
        })
        saveSearch(name, { extendedFilters, filters }, currentResults, pagination.totalRugs, user.id)
      } else {
        saveSearch(name, { extendedFilters, filters }, filteredRugs.slice(0, 4), pagination.totalRugs, user.id)
      }
    }

    handleSort = column => {
      const { setSortBy, sortBy, toggleSortOrder } = this.props

      if (sortBy === column) {
        toggleSortOrder()
      } else {
        setSortBy(column)
      }
    }

    setPage = page => {
      const { setPage } = this.props

      setPage(page)
      window.scrollTo(0, 0)
    }

    toggleMySearchesSaveModal = e => {
      const { mySearchesSaveModalOpen } = this.state
      const { resetSaveSearch } = this.props

      if (e) {
        e.preventDefault()
      }

      resetSaveSearch()

      this.setState({ mySearchesSaveModalOpen: !mySearchesSaveModalOpen })
    }

    render() {
      const { mySearchesSaveModalOpen } = this.state

      return (
        <WrappedComponent
          handleExportToExcel={this.handleExportToExcel}
          handleSaveSearch={this.handleSaveSearch}
          handleSort={this.handleSort}
          mySearchesSaveModalOpen={mySearchesSaveModalOpen}
          removeQueryFromUrl={this.removeQueryFromUrl}
          setPage={this.setPage}
          toggleMySearchesSaveModal={this.toggleMySearchesSaveModal}
          {...this.props}
        />
      )
    }
  }

  return Container
}
